/* ASSETS */

export const GET_ASSETS = "GET_ASSETS"
export const GET_ASSETS_FAIL = "GET_ASSETS_FAIL"
export const GET_ASSETS_SUCCESS = "GET_ASSETS_SUCCESS"

export const CREATE_BULK_CARDS = "CREATE_BULK_CARDS"
export const CREATE_BULK_CARDS_FAIL = "CREATE_BULK_CARDS_FAIL"
export const CREATE_BULK_CARDS_SUCCESS = "CREATE_BULK_CARDS_SUCCESS"
